'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Pin = function Pin(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 17 17' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { fill: 'currentColor' },
        _react2.default.createElement('path', { d: 'M8.588 2.495l.773.773-1.435 1.435H5.431L3.422 6.712l3.135 3.113L.83 15.46l.618.618 5.727-5.636 3.113 3.135 2.01-2.01V9.075l1.434-1.435.773.773L17 5.917 11.083 0 8.588 2.495zm5.917 4.68l-.773-.772-2.318 2.296v2.495l-1.126 1.125-5.607-5.607 1.125-1.126h2.495l2.318-2.318-.794-.773 1.258-1.259 4.68 4.68-1.258 1.26z'
        }),
        _react2.default.createElement('path', { d: 'M10.086 7.207l2.121-2.121.707.707-2.121 2.121z' })
      )
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Pin;